import React, { useRef } from 'react';
import { motion, MotionValue, useReducedMotion, useScroll, useTransform } from 'framer-motion';
type RevealWordsProps = {
  text: string;
  highlightWords?: string[];
  className?: string;
};
export function RevealWords({
  text,
  highlightWords = [],
  className = ''
}: RevealWordsProps) {
  const ref = useRef<HTMLParagraphElement>(null);
  const reduce = useReducedMotion();
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start 0.85', 'end 0.45']
  });
  const words = text.split(' ');
  return <p ref={ref} className={className} data-id="element-323" data-mp="2vswd4hax37dl">
      {words.map((word, i) => {
      const start = i / words.length;
      const end = start + 1 / words.length;
      return <Word key={i} progress={scrollYProgress} range={[start, end]} highlighted={highlightWords.includes(word)} reduce={!!reduce} data-id="element-324" data-mp="35j90sie13gny" data-mpi={i}>
            {word}
          </Word>;
    })}
    </p>;
}
type WordProps = {
  children: string;
  progress: MotionValue<number>;
  range: [number, number];
  highlighted: boolean;
  reduce: boolean;
};
function Word({
  children,
  progress,
  range,
  highlighted,
  reduce
}: WordProps) {
  const opacity = useTransform(progress, range, [0.15, 1]);
  return <>
      <motion.span style={{
      opacity: reduce ? 1 : opacity
    }} className={highlighted ? 'text-sunset' : undefined} data-id="element-325" data-mp="2rb3ga41skjvn">
        {children}
      </motion.span>{' '}
    </>;
}